class ViewModel {
  constructor(viewWrapperSelector, modelWrapperSelector, productGridSelector) {
    this.viewSquareWrapper = document.querySelector(viewWrapperSelector);
    this.modelSquareWrapper = document.querySelector(modelWrapperSelector);
    this.viewSquares = document.querySelectorAll(".view-square");
    this.productGrid = document.getElementById(productGridSelector);
    this.activeCount = 2;

    this.init();
  }

  init() {
    this.viewSquares[0].classList.add("active");
    this.viewSquares[1].classList.add("active");
    this.productGrid.classList.add("grid--4-col-desktop");
    this.updateGridClass();

    this.viewSquareWrapper.addEventListener("click", () =>
      this.toggleViewSquares()
    );
    this.modelSquareWrapper.addEventListener("click", () =>
      this.toggleModelSquares()
    );
  }

  toggleViewSquares() {
    if (this.activeCount < this.viewSquares.length) {
      this.viewSquares[this.activeCount].classList.add("active");
      this.activeCount++;
    } else {
      this.viewSquares.forEach((square) => square.classList.remove("active"));
      this.viewSquares[0].classList.add("active");
      this.activeCount = 1;
    }
    this.updateGridClass();
  }

  toggleModelSquares() {
    this.modelSquares = document.querySelectorAll(".model-square");
    const productGrid = document.getElementById("product-grid");

    productGrid.classList.toggle("model_view");

    this.modelSquares.forEach((square) => square.classList.toggle("active"));
  }

  updateGridClass() {
    const productGrid = document.getElementById("product-grid");
    productGrid.classList.remove(
      "grid--3-col-desktop",
      "grid--4-col-desktop",
      "grid--5-col-desktop"
    );
    switch (this.activeCount) {
      case 1:
        productGrid.classList.add("grid--3-col-desktop");
        break;
      case 2:
        productGrid.classList.add("grid--4-col-desktop");
        break;
      case 3:
        productGrid.classList.add("grid--5-col-desktop");
        break;
    }
  }
}

document.addEventListener("DOMContentLoaded", function () {
  new ViewModel(
    ".view-square-wrapper",
    ".model-square-wrapper",
    "product-grid"
  );
});
